import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { seller } from '../../constants/parameters';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Table, Button, Popconfirm } from 'antd';
import { TableRowActions } from '../';

class ParameterSellerTable extends Component {
  static propTypes = {
    dataSource: PropTypes.array,
    t: PropTypes.func.isRequired,
    deleteClassifier: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
  };

  getColumns = () => {
    const { t, deleteClassifier, showModal } = this.props;

    return [
      {
        title: t('tableSeller.code'),
        dataIndex: seller.CODE,
      },
      {
        title: t('tableSeller.name'),
        dataIndex: seller.NAME,
      },
      {
        title: t('tableSeller.sold'),
        dataIndex: seller.SOLD,
      },
      {
        title: t('tableSeller.actions'),
        render: (value) => (
          <TableRowActions>
            <Button
              shape="circle"
              icon={<EditOutlined />}
              size="small"
              type="primary"
              onClick={() => showModal(value[seller.CODE])}
            />
            <span className="ant-divider" />
            <Popconfirm
              title={t('popconfirm.title')}
              onConfirm={() => deleteClassifier(value[seller.CODE])}
              okText={t('popconfirm.buttonYes')}
              cancelText={t('popconfirm.buttonNo')}
            >
              <Button
                shape="circle"
                icon={<DeleteOutlined />}
                size="small"
                type="primary"
              />
            </Popconfirm>
          </TableRowActions>
        ),
      },
    ];
  };

  render() {
    const { dataSource } = this.props;

    return (
      <React.Fragment>
        <Table
          rowKey={seller.CODE}
          dataSource={dataSource}
          columns={this.getColumns()}
          pagination={false}
        />
      </React.Fragment>
    );
  }
}

export default ParameterSellerTable;
